// Module
var code = "<login></login>\n";
// Exports
module.exports = code;